import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import IntlMessages from "../utils/IntlMessages";
import lang_en from "../assets/images/en.png";
import lang_th from "../assets/images/th.png";
import profileImage from "../assets/images/profile.png";
import { checkLogin } from "../utils/apiUtil";

import {
  switchLanguage,
  toggleCollapsedNav,
  toggleCollapsedLang,
  toggleCollapsedMemberMenu,
  authProfileFetch,
  languageOpenPopup,
  authSignOut,
} from "../actions";

class NavMobile extends Component {

  constructor(props) {
    super(props);
    this.linkRef = React.createRef();
  }

  componentDidMount() {
    if (checkLogin() === true) {
      this.props.authProfileFetch();
    }
  }

  onChangeLang = (lang, e) => {
    this.props.languageOpenPopup();
  };

  render() {
    const {
      locale: { locale },
      authMember,
      profile
    } = this.props;

    return (
      <div className={`nav-mobile ${this.props.navCollapsed ? "active" : ""}`}>
        <div className="menu-list">
          {this.renderProfile(authMember, profile)}
          <ul className="menu-mobile-padding">
            <li>
              <Link to="/faq">
                <IntlMessages id="header.faq"></IntlMessages>
              </Link>
            </li>
            <li>
              <Link to="/contact">
                <IntlMessages id="header.contact"></IntlMessages>
              </Link>
            </li>
            <li>
              <Link to="/term">
                <IntlMessages id="header.term"></IntlMessages>
              </Link>
            </li>
          </ul>
          <div className="line-break"></div>
          <ul className="menu-mobile-padding">
            <li>
              <span onClick={(e) => this.onChangeLang(e)}>
                <IntlMessages id="header.language"></IntlMessages>
              </span>
              <span className="ico-lang" onClick={(e) => this.onChangeLang(e)}>
                {locale === "th" ? (
                  <img src={lang_th} alt="" />
                ) : (
                  <img src={lang_en} alt="" />
                )}
              </span>
            </li>
            {authMember && authMember.success ? (
              <li
                onClick={() => {
                  this.props.authSignOut();
                }}
              >
                <Link to="/">
                  <IntlMessages id="header.logout"></IntlMessages>
                </Link>
              </li>
            ) : (
              ""
            )}
          </ul>
        </div>
        <div className="nav-mobile-footer">
          <div>
            Powered by
            <br />
            World Reward Solutions
          </div>
        </div>
      </div>
    );
  }

  renderProfile(authMember, profile) {
    const {
      locale: { locale },
      auth
    } = this.props;
    
    if (checkLogin() === true) {
      return (
        <>
          <div className="menu-mobile-padding profile"
            onClick={() => {
              this.linkRef.current.click();
            }}
          >
              <div className="profile-image">
                <img src={profileImage} alt="Eastspring Wealth Privilege" />
              </div>
              <div className="profile-detail">
                <span className="name">
                  {authMember.member ? authMember.member.member_code : ""}
                </span>
                <br></br>
                <span className="level">{profile && profile.memberLevel?"Tier : "+profile.memberLevel:""}</span>
              </div>
          </div>
          <Link to="/my-profile" ref={this.linkRef} style={{display:"none"}}/>
          <div className="line-break"></div>
        </>
      );
    } else {
      return (
        <>
          <div className="menu-mobile-padding profile">
            <div className="profile-image">
              <img src={profileImage} alt="Eastspring Wealth Privilege" />
            </div>
            <div className="profile-detail">
              <Link to="/authen">
                <span 
                className="login"  
                onClick={() => {
                  this.props.toggleCollapsedNav();
                }} 
                > {locale === "th" ?'เข้าสู่ระบบ':'Log in'}</span>
              </Link>
            </div>
          </div>
          <div className="line-break"></div>
        </>
      );
    }
  }
}

const mapStateToProps = ({ setting, auth }) => {
  const { locale, navCollapsed, langCollapsed, memberMenuCollapsed } = setting;
  const { authMember, profile } = auth;
  return {
    locale,
    navCollapsed,
    langCollapsed,
    memberMenuCollapsed,
    authMember,
    profile
  };
};

export default connect(mapStateToProps, {
  switchLanguage,
  authProfileFetch,
  toggleCollapsedNav,
  toggleCollapsedLang,
  toggleCollapsedMemberMenu,
  languageOpenPopup,
  authSignOut,
})(NavMobile);
